<dms-control [dmsTraduction]="this.dmsTraduction" >
	<div class="input-group">
		<input type="text" class="form-control SM-datetimepicker" #picker >
		<span class="input-group-btn">
			<button class="btn btn-primary" type="button" (click)="focusOnPicker()" >
				<i class="fa fa-calendar-o"></i>
			</button>
		</span>
	</div>
</dms-control>